import React, { Suspense } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { BrowserRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Loader from './components/reusable/Loader';
import Payment from './components/views/Payment/Payment';

const Login = React.lazy(() => import('./components/views/Login/Login'));
const Layout = React.lazy(() => import('./Layout/Layout'));
const Page404 = React.lazy(() => import('./components/views/Page404/Page404'));

const App = () => (
  <div>
    <Toaster />
    <BrowserRouter basename="">
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route path="/login" exact component={Login} />
          <Route path="/not-found" component={Page404} />
          <Route path="/venmo" component={Payment} />
          <Route path="*" name="Home" component={Layout} />
          <Redirect from="/" to="/login" />
        </Switch>
      </Suspense>
    </BrowserRouter>
  </div>
);

export default App;
